<template>
  <b-card>
  <b class="mb-2">Rechazos</b>
    <DxDataGrid
      :data-source="rechazos"
      :show-borders="true"
      :show-column-lines="true"
      :show-row-lines="true"
      :row-alternation-enabled="true"
      :columnAutoWidth="true"
      :allow-column-resizing="true"
      v-if="rechazos.length"
    >
      <DxSearchPanel :visible="false" :width="240" placeholder="Buscar..." />
      <DxPaging :page-size="15" />
      <DxHeaderFilter :visible="true" />
      <DxFilterRow :visible="true">
        <DxOperationDescriptions
          equal="Igual a"
          notEqual="Diferente de"
          startsWith="Empieza con"
          endsWith="Termina con"
          contains="Contiene"
          between="Entre"
          notContains="No contiene"
          lessThanOrEqual="Menor o igual"
          greaterThanOrEqual="Mayor o igual"
          lessThan="Menor que"
          greaterThan="Mayor que"
        />
      </DxFilterRow>
      <DxPager
        :visible="false"
        infoText="Página {0} of {1} ({2} registros)"
        :allowed-page-sizes="pageSizes"
        display-mode="full"
        :show-page-size-selector="true"
        :show-info="true"
        :show-navigation-buttons="true"
      />
      <DxColumn data-field="brigada" caption="Brigada" />
      <DxColumn data-field="motivo.descripcion" caption="Motivo" />
      <DxColumn
        data-field="observacion"
        caption="Observación brigada"
        width="400"
      />
      <DxColumn
        data-field="fecha_rechazo"
        caption="Fecha rechazo"
        data-type="date"
        format="dd/MM/yyyy, HH:mm:ss"
      />
    </DxDataGrid>
  </b-card>
</template>

<script>
import {
  DxDataGrid,
  DxPaging,
  DxColumn,
  DxSearchPanel,
  DxFilterRow,
  DxHeaderFilter,
  DxPager,
  DxOperationDescriptions,
} from "devextreme-vue/data-grid";
export default {
  name: "order-rechazos-tab",
  components: {
    DxDataGrid,
    DxPaging,
    DxColumn,
    DxSearchPanel,
    DxFilterRow,
    DxHeaderFilter,
    DxPager,
    DxOperationDescriptions,
  },
  props: {
    rechazos: {
      type: Array,
      default: () => [],
    },
  },
  data(){
    return {
        pageSizes: [5, 10, 15, 30],
    }
  }
};
</script>
<style>
.dx-header-row > td[aria-label="Column Brigada"],
.dx-header-row > td[aria-label="Column Motivo"],
.dx-header-row > td[aria-label="Column Observación brigada"],
.dx-header-row > td[aria-label="Column Fecha rechazo"] {
  overflow-x: hidden !important;
}
</style>
